export const isOrgSwitchNotFoundError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;

  const err = error as {
    status?: number;
    message?: string;
    errors?: { code?: string }[];
  };

  const message = err.message?.toLowerCase() ?? '';

  return (
    err.status === 404
    || err.errors?.[0]?.code === 'resource_not_found'
    || message.includes('not found')
    || message.includes('not a member')
    || message.includes('timed out')
    || message.includes('timeout')
  );
};
